export const titleStyled = {
  marginTop: '10',
}

export const textUppercase = {
  textTransform: 'uppercase',
}

export const textBlackStyled = {
  fontSize: '15px',
  fontWeight: 500,
  gap: 8,
}

export const textGreenStyled = {
  color: 'var(--flora--colors-brand-3)',
  fontSize: '14px',
  fontWeight: 500,
  gap: 8,
}

export const headerStyled = {
  margin: '2em 0',
}

export const headingStyled = {
  display: 'block',
  color: 'var(--flora--colors-dark-dark)',
}

export const boxStyled = {
  flexGrow: 2,
  alignSelf: 'stretch',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export const flexStyled = {
  flexGrow: 0.395,
}

export const spanStyled = {
  display: 'none',
}

export const radioGroupStyled = {
  paddingBottom: '16px',
}

export const tagStyled = {
  background: '$light-dark-1',
  fontSize: 20,
  minWidth: 104,
  padding: 12,
}

export const buttonStyled = {
  padding: '16px 42px',
}
